import { ReactNode } from 'react';
import { Button, Flex, FlexColumn } from '@elementary/common-ui/components';
import { ReactComponent as PlusIcon } from '@elementary/common-ui/assets/plus-2.svg';
import { Typography } from '@mui/material';

type Props = {
  title: string;
  actionLabel?: string;
  onAction?: () => void;
  children: ReactNode;
};

const SettingsSection = ({ title, actionLabel, onAction, children }: Props) => (
  <FlexColumn role="region" aria-label={title} sx={{ gap: 1.5 }}>
    <Flex
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: '32px',
      }}
    >
      <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: '12px',
          color: 'common.gray11',
          textTransform: 'uppercase',
        }}
      >
        {title}
      </Typography>
      {actionLabel && onAction && (
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<PlusIcon />}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Flex>
    {children}
  </FlexColumn>
);

export default SettingsSection;
